export default "/images/hero.jpg?4313aed7c178b8cd5e3432f80b6ad26d";